<template>
    <div class="header-title">
        <img v-if="logoUrl" :src="logoUrl"/>
        <img v-if="titleUrl" :src="titleUrl" style="margin-left:38px;"/>
    </div>
</template>

<style scoped>
.header-title{
    margin: 0 auto;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 20px;
}
.header-title img{
    display: inline;
    vertical-align: middle;
}
</style>

<script>
export default {
    name: 'HeadTitle',
    props:{
        titleUrl:{
            type:String,
            default:''
        },
        logoUrl:{
            type:String,
            default:''
        }
    },
}
</script>




// WEBPACK FOOTER //
// src/components/HeadTitle.vue